import {
    GET_PROPOSED_LINKS,
    PROPOSED_LINKS_RECEIVED,
    TOGGLE_PROPOSED_CHANGES,
    SET_PROPOSED_LINKS_FILTERS,
    GET_PROPOSED_LINK_INFO,
    SET_PROPOSED_LINK_INFO,
    GetProposedLinksAction,
    ProposedLinksReceivedAction,
    ToggleProposedChangesAction,
    SetProposedLinksFiltersAction,
    SetProposedLinkInfoAction,
    getProposedLinkInfoAction,
    toggleProposedLayerAction,
    TOGGLE_PROPOSED_LAYER
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const getProposedLinks = createAction<GetProposedLinksAction["payload"]>(GET_PROPOSED_LINKS);

export const proposedLinksReceived =
    createAction<ProposedLinksReceivedAction["payload"]>(PROPOSED_LINKS_RECEIVED);

export const toggleProposedChanges =
    createAction<ToggleProposedChangesAction["payload"]>(TOGGLE_PROPOSED_CHANGES);

export const toggleProposedLayer =
    createAction<toggleProposedLayerAction["payload"]>(TOGGLE_PROPOSED_LAYER);

export const setProposedLinksFilters = createAction<SetProposedLinksFiltersAction["payload"]>(
    SET_PROPOSED_LINKS_FILTERS
);

export const getProposedLinkInfo =
    createAction<getProposedLinkInfoAction["payload"]>(GET_PROPOSED_LINK_INFO);

export const setProposedLinkInfo =
    createAction<SetProposedLinkInfoAction["payload"]>(SET_PROPOSED_LINK_INFO);
